import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import { Menu, Modal, Icon } from 'antd';
import { logout, getProfile } from '../../utilities//services/AuthService';

const { SubMenu } = Menu;
const { confirm } = Modal;

const milesManagementGroup = [
	{ menucode: 'PTRANSFERP', accesscode: 'PTRANFRP_ACCESS' },
];

const voucherManagementGroup = [
	{ menucode: 'PVCHRMGT', accesscode: 'PVCHRMGT_ACCESS' },
	{ menucode: 'PVCHRVRFY', accesscode: 'PVCHRVRFY_ACCESS' },
	{ menucode: 'PVCHRLIST', accesscode: 'PVCHRLST_ACCESS' },
];

const fileManagementPartnerGroup = [
	{ menucode: 'PENROLLMENT', accesscode: 'PENROLL_ACCESS' },
	{ menucode: 'PTERMINATE', accesscode: 'PTERMINT_ACCESS' },
	{ menucode: 'PAPPRVCOBRAND', accesscode: 'PAPPRVCO_ACCESS' },
	{ menucode: 'PCBRNDFST', accesscode: 'PCBRNFST_ACCESS' },
]

const orderManagementPartnerGroup = [
	{ menucode: 'PDLVRYORDER', accesscode: 'PPRNTORD_ACCESS' },
	{ menucode: 'PPCKGORDER', accesscode: 'PPCKGORD_ACCESS' },
	{ menucode: 'PPRNTORDER', accesscode: 'PPRNTORD_ACCESS' },
]

class App extends React.Component {
	clickLogout() {
		confirm({
			title: 'Are you sure want to logout?',
			onOk() { logout() },
			onCancel() { },
		});
	}

	render() {
		const { usermenu } = this.props.permission;
		const { username } = getProfile();

		return (
			<Menu theme="light" mode="horizontal" defaultSelectedKeys={['2']} style={{ lineHeight: '64px', textAlign: 'right' }}>
				<Menu.Item key="1">
					<Link to={"/"}>Dashboard</Link>
				</Menu.Item>
				<SubMenu title="Miles Management" className={_checkPermissionMenuGroup(usermenu, milesManagementGroup)}>
					<Menu.Item key="MILES:1" className={_checkPermission(usermenu, 'PMBRMGT', 'PMBRMGT_ACCESS')}>
						<Link to={"/member"}>Member Management</Link>
					</Menu.Item>
					<Menu.Item key="MILES:2" className={_checkPermission(usermenu, 'PTRANSFERP', 'PTRANFRP_ACCESS')}>
						<Link to={"/file-transfer-point"}>Transfer Point</Link>
					</Menu.Item>
				</SubMenu>
				<SubMenu title="Voucher Management" className={_checkPermissionMenuGroup(usermenu, voucherManagementGroup)}>
					<Menu.Item key="VOUCHER:1" className={_checkPermission(usermenu, 'PVCHRMGT', 'PVCHRMGT_ACCESS')}>
						<Link to={"/file-voucher"}>Partner 	Voucher</Link>
					</Menu.Item>
					<Menu.Item key="VOUCHER:2" className={_checkPermission(usermenu, 'PVCHRLIST', 'PVCHRLST_ACCESS')}>
						<Link to={"/voucher-management/voucher-list"}>Voucher List</Link>
					</Menu.Item>
					<Menu.Item key="VOUCHER:3" className={_checkPermission(usermenu, 'PVCHRVRFY', 'PVCHRVRFY_ACCESS')}>
						<Link to={"/voucher-management/voucher-verification"}>Voucher Verification</Link>
					</Menu.Item>
				</SubMenu>
				<SubMenu title="File Management" className={_checkPermissionMenuGroup(usermenu, fileManagementPartnerGroup)}>
					<Menu.Item key="FILE:1" className={_checkPermission(usermenu, 'PAPPRVCOBRAND', 'PAPPRVCO_ACCESS')}>
						<Link to={"/file-approval-cobrand"}>Approval Cobrand</Link>
					</Menu.Item>
					<Menu.Item key="FILE:2" className={_checkPermission(usermenu, 'PENROLLMENT', 'PENROLL_ACCESS')}>
						<Link to={"/file-enrollment"}>Enrollment</Link>
					</Menu.Item>
					<Menu.Item key="FILE:3" className={_checkPermission(usermenu, 'PTERMINATE', 'PTERMINT_ACCESS')}>
						<Link to={"/file-terminate"}>Terminate</Link>
					</Menu.Item>
					<Menu.Item key="FILE:4" className={_checkPermission(usermenu, 'PCBRNDFST', 'PCBRNFST_ACCESS')}>
						<Link to={"/file-cobrand-fast-track"}>Cobrand Fast Track</Link>
					</Menu.Item>
				</SubMenu>
				<SubMenu title="Order Management" className={_checkPermissionMenuGroup(usermenu, orderManagementPartnerGroup)}>
					<Menu.Item key="ORDER:1" className={_checkPermission(usermenu, 'PPRNTORDER', 'PPRNTORD_ACCESS')}>
						<Link to={"/order-management/printing"}>Printing Order</Link>
					</Menu.Item>
					<Menu.Item key="ORDER:2" className={_checkPermission(usermenu, 'PPCKGORDER', 'PPCKGORD_ACCESS')}>
						<Link to={"/order-management/package"}>Package Order</Link>
					</Menu.Item>
					<Menu.Item key="ORDER:3" className={_checkPermission(usermenu, 'PDLVRYORDER', 'PDLVYORD_ACCESS')}>
						<Link to={"/order-management/delivery"}>Delivery Order</Link>
					</Menu.Item>
				</SubMenu>
				<SubMenu title={"Hi, " + username}>
					<Menu.Item>
						<Link to={"/profile"}><Icon type="user" />Profile</Link>
					</Menu.Item>
					<Menu.Item>
						<Link onClick={this.clickLogout}><Icon type="logout" />Logout</Link>
					</Menu.Item>
				</SubMenu>
			</Menu >
		)
	}
}

export function _checkPermission(usermenu, menucode, functioncode) {
	let result = '';
	if (usermenu[menucode] && !usermenu[menucode][functioncode]) {
		result = "hidden";
	}
	return result;
}

export function _checkPermissionMenuGroup(usermenu, module) {
	// const { branchcode, tickoffid } = getProfile();
	// let isUserBranch = branchcode && tickoffid;
	//default menu group is hidden
	let result = 'hidden';
	//check permission each module
	// if (isUserBranch) {
	for (const field in module) {
		var menucode = module[field]['menucode'];
		var accesscode = module[field]['accesscode'];
		if (usermenu[menucode] !== undefined && usermenu[menucode][accesscode]) {
			result = '';
			break;
		}
	}
	// }
	return result;
}

// export default Menu;
const mapStateToProps = state => ({ ...state });
export default connect(mapStateToProps)(App);
